module.exports = __webpack_public_path__ + "static/media/ev13.f7f8a999.jpg";